export const LEAD_VIEWS = {
  TABLE: 'table',
  KANBAN: 'kanban',
  CALENDAR: 'calendar',
  DOUBLE_BOOKING_TABLE: 'double_booking_table',
}

export const LEADS_GROUP_BY = {
  LEAD_STATE: 'lead_state',
  ASSIGNEE: 'assignee',
  LEAD_SOURCE: 'lead_source',
  SERVICE_TYPE: 'service_type',
  LAST_APPOINTMENT: 'last_appointment_date',
  PRIORITY: 'priority',
}

export const GROUPS_TO_BE_LOADED = {
  ALL: 'all',
  [LEADS_GROUP_BY.LEAD_STATE]: 'all',
  [LEADS_GROUP_BY.LEAD_SOURCE]: 'all',
  [LEADS_GROUP_BY.PRIORITY]: 'all',
  [LEADS_GROUP_BY.SERVICE_TYPE]: 10,
  [LEADS_GROUP_BY.LAST_APPOINTMENT]: 10,
  [LEADS_GROUP_BY.ASSIGNEE]: 10,
}
